/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Surface_ApiInputs */

const en_marketing_surface_api = /** @type {(inputs: Marketing_Surface_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public API`)
};

const es_marketing_surface_api = /** @type {(inputs: Marketing_Surface_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API pública`)
};

const fr_marketing_surface_api = /** @type {(inputs: Marketing_Surface_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API publique`)
};

/**
* | output |
* | --- |
* | "Public API" |
*
* @param {Marketing_Surface_ApiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_surface_api = /** @type {((inputs?: Marketing_Surface_ApiInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Surface_ApiInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_surface_api(inputs)
	if (locale === "es") return es_marketing_surface_api(inputs)
	return fr_marketing_surface_api(inputs)
});